import D1 from '../../components/ExcerciseTypes/Design/TypeIn';

const json = {
  1: { // Exercise num
    unit: 'Starter',
    id: 'WB3-S-P5-E1',
    audio: '',
    video: '',
    isAllowSubmit: false,
    component: D1,
    hideBtnFooter: true,
    checkUppercase: true,
    questionImage: [ // Row
      [
        { url: 'img/FriendsPlus/Page5/E1/1.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page5/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page5/E1/3.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page5/E1/4.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page5/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page5/E1/6.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page5/E1/7.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page5/E1/8.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page5/E1/9.jpg' },
        { url: 'img/FriendsPlus/Page5/E1/10.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page5/E1/11.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page5/E1/12.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page5/E1/13.jpg' },
        { url: 'img/FriendsPlus/Page5/E1/14.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page5/E1/15.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page5/E1/16.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page5/E1/17.jpg' },
        { url: 'img/FriendsPlus/Page5/E1/18.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page5/E1/19.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page5/E1/20.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page5/E1/21.jpg' },
        { url: 'img/FriendsPlus/Page5/E1/22.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page5/E1/23.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page5/E1/24.jpg' },
      ],
    ],
  },
  2: { // Exercise num
    unit: 'Starter',
    id: 'WB3-S-P5-E2',
    audio: '',
    video: '',
    component: D1,
    checkUppercase: true,
    exerciseKey: 'img/FriendsPlus/Page5/E2/Key/answerKey.png',

    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page5/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page5/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page5/E2/3.jpg', input: true, answer: "This is Rosy's dad." },
        { url: 'img/FriendsPlus/Page5/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page5/E2/5.jpg', input: true, answer: "b" },
        { url: 'img/FriendsPlus/Page5/E2/6.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page5/E2/7.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page5/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page5/E2/9.jpg', input: true, answer: "This is Rosy's cousin." },
        { url: 'img/FriendsPlus/Page5/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page5/E2/11.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page5/E2/12.jpg' },
      ],
    ],
  },

}

export default json;